// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.add-to-order-button {
  margin: 12px;
}

ion-button {
  width: 100%;
  min-height: 54px;
  --background: #2D69AA;
  font-family: BricolageGrotesque;
  font-size: 17px;
  font-weight: 700;
}

.wrapper {
  background-color: var(--color-background-alt);
}

.vertical-line {
  height: 55%;
  width: 0.6px;
  margin-inline: 10px;
  background-color: #fff;
}

.quantity {
  width: 25px;
  height: 25px;
  border: 1px solid var(--color-black);
  border-radius: 50%;
  background: var(--color-background-alt);
  display: flex;
  align-items: center;
  justify-content: center;
  margin-right: 10px;
  color: var(--color-black);
}`, "",{"version":3,"sources":["webpack://./src/app/components/to-order-button/to-order-button.component.scss"],"names":[],"mappings":"AAAA;EACE,YAAA;AACF;;AACA;EACE,WAAA;EACA,gBAAA;EACA,qBAAA;EACA,+BAAA;EACA,eAAA;EACA,gBAAA;AAEF;;AACA;EACE,6CAAA;AAEF;;AACA;EACE,WAAA;EACA,YAAA;EACA,mBAAA;EACA,sBAAA;AAEF;;AACA;EACE,WAAA;EACA,YAAA;EACA,oCAAA;EACA,kBAAA;EACA,uCAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,kBAAA;EACA,yBAAA;AAEF","sourcesContent":[".add-to-order-button {\n  margin: 12px;\n}\nion-button {\n  width: 100%;\n  min-height: 54px;\n  --background: #2D69AA;\n  font-family: BricolageGrotesque;\n  font-size: 17px;\n  font-weight: 700;\n}\n\n.wrapper {\n  background-color: var(--color-background-alt);\n}\n\n.vertical-line {\n  height: 55%;\n  width: 0.6px;\n  margin-inline: 10px;\n  background-color: #fff;\n}\n\n.quantity {\n  width: 25px;\n  height: 25px;\n  border: 1px solid var(--color-black);\n  border-radius: 50%;\n  background: var(--color-background-alt);\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  margin-right: 10px;\n  color: var(--color-black);\n}"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
